module.exports = __webpack_public_path__ + "static/media/fk.f202e72c.svg";